import { defaultApi } from '@/plugins/api/defaultApi'

export default {
  name: 'loanMarketplace',
  namespaced: true,
  state: {
    loanOffers: null,
    loanOffersLoading: false,
  },
  getters: {
    getLoanOffersLoading(state) {
      return state.loanOffersLoading
    },
  },
  mutations: {
    setLoanOffers(state, loanOffers) {
      state.loanOffers = loanOffers
    },
    setLoanOffersLoading(state, loading) {
      state.loanOffersLoading = loading
    },
  },
  actions: {
    async getLoanOfferByUuid({ state, dispatch }, uuid) {
      return state.loanOffers?.find((loanOffer) => loanOffer.uuid === uuid)
    },

    async applyLoanOffer({ dispatch }, uuid) {
      await defaultApi.postMarketplaceLoanOfferApply(uuid)
    },

    async createLoanOffers({ commit }, form) {
      commit('setLoanOffersLoading', true)
      try {
        const { data } = await defaultApi.postMarketplaceLoanOffers(form)
        commit('setLoanOffers', data)
        return data
      } finally {
        commit('setLoanOffersLoading', false)
      }
    },
  },
}
